import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import AxiosConfig from '../../../config/AxiosConfig';

const OverviewTab = ({ setValue, _sensitiveDataAllowedToUser }) => {
  const [overviewStats, setOverviewStats] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchOverviewData = async () => {
      setIsLoading(true);
      try {
        await AxiosConfig.create('get', '/stats/overview')
          .call()
          .exit((res) => {
            setOverviewStats(res?.data);
          });
      } catch (error) {
        console.error('Error fetching overview stats:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchOverviewData();
  }, []);

  if (isLoading) {
    return (
      <Typography>Chargement des statistiques de l&apos;overview...</Typography>
    );
  }

  if (!overviewStats) {
    return (
      <Typography>
        Impossible de charger les statistiques de l&apos;overview.
      </Typography>
    );
  }

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" gutterBottom>
        Vue d&apos;ensemble
      </Typography>
      <Grid container spacing={3}>
        {/* Indicateurs Clés (KPIs) */}
        <Grid size={12}>
          <Card>
            <CardContent>
              <Typography variant="h5">
                {overviewStats?.totalOpenTickets || 0}
              </Typography>
              <Typography color="textSecondary">Tickets Ouverts</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid size={12}>
          <Card>
            <CardContent>
              <Typography variant="h5">
                {overviewStats?.activeOperators || 0}
              </Typography>
              <Typography color="textSecondary">Opérateurs Actifs</Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Résumé par Statut (Graphique simple ou tableau) */}
        <Grid size={12}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="subtitle1" gutterBottom>
              Répartition des Tickets par Statut
            </Typography>
            {overviewStats?.ticketsByStatus && (
              <ul>
                {['NEW', 'INPROGRESS', 'WAITING', 'PROCESSED'].map((status) => (
                  <li key={status}>
                    {status}: {overviewStats.ticketsByStatus[status] || 0}
                  </li>
                ))}
                {/* Afficher les autres statuts s'il y en a */}
                {Object.entries(overviewStats.ticketsByStatus)
                  .filter(
                    ([status]) =>
                      !['NEW', 'INPROGRESS', 'WAITING', 'PROCESSED'].includes(
                        status
                      )
                  )
                  .map(([status, count]) => (
                    <li key={status}>
                      {status}: {count}
                    </li>
                  ))}
              </ul>
            )}
          </Paper>
        </Grid>

        {/* Liens vers les Sections Détaillées */}
        <Grid size={12}>
          <Paper sx={{ p: 2, textAlign: 'center' }}>
            <Stack direction="row" justifyContent="center" spacing={2}>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => setValue(2)}
              >
                Statistiques des Opérateurs
              </Button>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => setValue(3)}
              >
                Performances des Opérateurs
              </Button>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => setValue(4)}
              >
                Activité des Tickets
              </Button>
            </Stack>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default OverviewTab;
